import React, { useState, useEffect } from "react";
import { Select, Card, Spin, Row, Col, message, Modal } from "antd";
import ReactECharts from "echarts-for-react";
import httpUtil from "../../utils/httpUtil";
import { EchartsRadar } from "../echartsRadar/EchartsRadar";

const { Option } = Select;

export const CheckResult = ({ userInfo }) => {
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedTerm, setSelectedTerm] = useState("");
  const [classes, setClasses] = useState([]);
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(""); // 新增：选中的学生信息
  const [modalVisible, setModalVisible] = useState(false); // 新增：控制Modal显示
  const [radarData, setRadarData] = useState([]);

  //获取全部学期
  const generateTermOptions = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 月份1-12
    const enrollmentYear = currentYear - 4;
    const terms = [];

    // 生成所有可能的学期（直到当前年份）
    for (let year = enrollmentYear; year <= currentYear - 1; year++) {
      // 第一学期（当年9月1日 - 次年1月31日）
      terms.push({
        term_id: `${year}-1`,
        term_name: `${year}学年第一学期`,
        start_date: `${year}-09-01`,
        end_date: `${year + 1}-01-31`, // 跨年到次年1月
      });

      // 第二学期（次年2月1日 - 次年8月31日）
      terms.push({
        term_id: `${year}-2`,
        term_name: `${year}学年第二学期`,
        start_date: `${year + 1}-02-01`,
        end_date: `${year + 1}-08-31`, // 延长到8月31日
      });
    }
    // 根据当前日期过滤学期
    if (currentMonth <= 1) {
      // 1月及之前：去掉最后一个学期数据
      return terms.slice(0, -1);
    } else {
      // 2月及之后：返回全部
      return terms;
    }
  };

  //获取全部班级和学期
  const getAllClass = () => {
    httpUtil.geAllClasses({ username: userInfo.username }).then((res) => {
      if (res.success) {
        setClasses(res.data);
      }
    });
    setTerms(generateTermOptions());
  };

  useEffect(() => {
    getAllClass();
  }, []);

  // 获取评价结果
  const fetchData = (classId, termId) => {
    setLoading(true);
    try {
      const parmas = {
        teacher_id: userInfo.username,
        class_id: classId,
        term: termId,
      };
      console.log(parmas);
      httpUtil.getClassEvaluationByTeacher(parmas).then((res) => {
        if (res.success) {
          if (res.data.count === 0) {
            message.info(res.message);
          }
          setChartData(res.data.results);
        }
      });
    } catch (error) {
      console.error("获取评价结果失败:", error);
      message.error("获取数据失败，请稍后重试");
    } finally {
      setLoading(false);
    }
  };

  // 处理班级选择变化
  const handleClassChange = (value) => {
    setSelectedClass(value);
    if (selectedTerm) {
      fetchData(value, selectedTerm);
    }
  };

  // 处理学期选择变化
  const handleTermChange = (value) => {
    setSelectedTerm(value);
    if (selectedClass) {
      fetchData(selectedClass, value);
    }
  };

  const chartOptions = {
    title: {
      text: "班级综合素质评价（按分数升序排列）",
      left: "center",
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: "{b}<br/>分数: {c}",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "20%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: chartData.map((item) => item.student_name),
      axisLabel: {
        rotate: 45,
        interval: 0,
        fontSize: 10,
        margin: 10,
      },
    },
    yAxis: {
      type: "value",
      name: "综合评分",
      min: 30,
      max: 100,
      axisLine: {
        show: true,
      },
    },
    series: [
      {
        name: "综合素质评分",
        type: "bar",
        barWidth: "60%",
        data: chartData.map((item) => item.total_score),
        itemStyle: {
          color: function (params) {
            const score = params.data;
            return score >= 90
              ? "#52c41a" // 优秀-绿色
              : score >= 80
              ? "#1890ff" // 良好-蓝色
              : score >= 70
              ? "#faad14" // 中等-黄色
              : "#ff4d4f"; // 待提高-红色
          },
          borderRadius: [4, 4, 0, 0],
        },
        label: {
          show: true,
          position: "top",
          formatter: "{c}",
          fontSize: 10,
          fontWeight: "bold",
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  // 处理柱状图点击事件
  const onChartClick = (params) => {

    const clickedStudent = chartData[params.dataIndex];
    

    const formattedRadarData = clickedStudent.details.map((item) => ({
      ...item,
      score: Number(item.score),
    }));
    setRadarData(formattedRadarData);
    setSelectedStudent(clickedStudent.student_name);
    console.log(selectedStudent);
    setModalVisible(true);
  };

  // 关闭Modal
  const handleModalClose = () => {
    setModalVisible(false);
  };

  return (
    <div style={{ maxHeight: "70vh", paddingTop:"24px" }}>
      <Card variant={false} style={{ padding: 0, maxHeight: "70vh" }}>
        <Row gutter={16} style={{ marginBottom: "24px", maxHeight: "70vh" }}>
          <Col span={12}>
            <Select
              placeholder="请选择班级"
              style={{ width: "100%" }}
              onChange={handleClassChange}
              size="large"
            >
              {classes.map((cls) => (
                <Option key={cls.name} value={cls.name}>
                  {cls.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={12}>
            <Select
              placeholder="请选择学期"
              style={{ width: "100%" }}
              onChange={handleTermChange}
              size="large"
            >
              {terms.map((term) => (
                <Option key={term.term_id} value={term.term_id}>
                  {term.term_name}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>

        {loading ? (
          <div style={{ textAlign: "center", padding: "100px 0" }}>
            <Spin size="large" tip="数据加载中..." />
          </div>
        ) : (
          selectedClass &&
          selectedTerm && (
            <div>
              {chartData.length > 0 ? (
                <ReactECharts
                  option={chartOptions}
                  style={{ height: "65vh", width: "100%" }}
                  theme="light"
                  onEvents={{
                    click: onChartClick, // 添加点击事件监听
                  }}
                />
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "50px",
                    color: "rgba(0, 0, 0, 0.45)",
                  }}
                >
                  暂无该学期评价数据
                </div>
              )}
            </div>
          )
        )}

        {/* 添加Modal弹窗 */}
        <Modal
          title={`${selectedStudent} 同学详细评价信息`}
          open={modalVisible}
          onCancel={handleModalClose}
          footer={null}
          width={700}
          destroyOnHidden
        >
          <EchartsRadar data={radarData} height={400} />
        </Modal>
      </Card>
    </div>
  );
};
